import {RiGeminiFill} from "../ai/icons/RiGeminiFill";
import type {EditorIconProps} from "../icons";
export default function Gemini({style, className}: EditorIconProps) { return <RiGeminiFill style={style} className={className}/>; }
